import { GetLookupVhcInput, useLookupVhcQuery } from 'features/vhc/api/lookup.query';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';

type FormState = { input: string } & GetLookupVhcInput;

export const useVhcCreateLookupForm = () => {
  const {
    reset: resetLookUpValues,
    control: lookUpControl,
    formState: { errors: lookUpErrors, isValid: lookUpIsValid },
    watch: lookUpWatch,
    setValue: setLookUpValue
  } = useForm<FormState>({
    defaultValues: {
      wip: undefined,
      branchId: undefined
    },
    mode: 'onChange'
  });

  const lookUp = lookUpWatch('input');
  const branchId = lookUpWatch('branchId');

  function isNumericString(value: string): boolean {
    return /^\d+$/.test(value);
  }

  const inputData: GetLookupVhcInput = isNumericString(lookUp?.toString() ?? '')
    ? {
        wip: Number(lookUp?.trim()),
        branchId: branchId,
        regNo: undefined,
        activeOnly: true
      }
    : {
        wip: undefined,
        regNo: lookUp?.trim(),
        branchId: branchId,
        activeOnly: true
      };

  const { refetch: refetchLookup, isFetching: isLookingUp } = useLookupVhcQuery(inputData, undefined, {
    enabled: false,
    onSuccess: (data) => {
      if (!data) {
        toast.info('WIP not found');
      }
    }
  });

  return {
    lookUpControl,
    lookUpErrors,
    lookUpIsValid,
    refetchLookup,
    isLookingUp,
    branchId,
    resetLookUpValues,
    setLookUpValue,
    lookUpWatch
  };
};
